import axios from "axios";

/**
 * Resolves the backend base URL with a runtime override:
 *  1. window.ZEFERIUS_BACKEND_URL (loaded from /config.js — editable on the host)
 *  2. REACT_APP_BACKEND_URL baked at build time
 * This lets the deployed site point at a different backend without rebuild.
 */
function resolveBackendUrl() {
  if (typeof window !== "undefined") {
    const runtime = (window.ZEFERIUS_BACKEND_URL || "").trim().replace(/\/$/, "");
    if (runtime) return runtime;
  }
  return (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fidelis_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Network errors (no response) — usually CORS, offline, server down
    if (!err?.response) {
      const code = err?.code || "ERR_NETWORK";
      const friendly = `Erro de conexão (${code}). Verifique sua internet ou se o servidor está acessível em ${BACKEND_URL}.`;
      // eslint-disable-next-line no-console
      console.error("[API]", friendly, err);
      err.message = friendly;
      return Promise.reject(err);
    }
    if (err.response.status === 401) {
      localStorage.removeItem("fidelis_token");
      localStorage.removeItem("fidelis_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
